import { render, staticRenderFns } from "./ViewProductOrderItemChangeRequestsPopUp.vue?vue&type=template&id=bf511a2c&scoped=true&"
import script from "./ViewProductOrderItemChangeRequestsPopUp.vue?vue&type=script&lang=js&"
export * from "./ViewProductOrderItemChangeRequestsPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ViewProductOrderItemChangeRequestsPopUp.vue?vue&type=style&index=0&id=bf511a2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf511a2c",
  null
  
)

export default component.exports